import { render } from "./AppButton.vue?vue&type=template&id=3ec910a0"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__